export function reconcilePlan(i) {
    if (!i.supported || !i.permissionGranted)
        return "skip";
    if (!i.live)
        return i.stored ? "resubscribe_lost" : "skip";
    if (i.live.keyMatches === false)
        return "resubscribe_key";
    if (!i.stored)
        return "match"; // подписка есть, но устройство у нас не включали — не трогаем
    if (!i.stored.endpoint)
        return "backfill";
    return i.stored.endpoint === i.live.endpoint ? "match" : "reregister";
}
/** Хвост endpoint для диагностики: последние 8 символов, без хоста и без утечки токена целиком. */
export const endpointTail = (e) => (e ? e.slice(-8) : "-");
//# sourceMappingURL=reconcilePlan.js.map